import Register from "views/examples/Register.js";
import Login from "views/examples/Login.js";
import EmailVerificationPending from "views/examples/EmailVerificationPending.js";
import FansRequestingSkype from "views/examples/FansRequestingSkype";
import ChangePassword from "views/examples/ChangePassword";
import RegistrationFee from "views/examples/RegistrationFee";
import Profile from "views/examples/Profile/index";
import ForgotPassword from "views/examples/ForgotPassword";
import ComplaintForm from "views/examples/ComplaintForm";
import ImproveChanceToSellLicenses from "views/examples/ImproveChanceToSellLicenses";
import RequestedCities from "views/examples/RequestedCities";
import RequestedSports from "views/examples/RequestedSports";
import InstructionsReadFirst from "views/examples/InstructionsReadFirst";
import CollectiveAlumJoin from "views/examples/CollectiveAlumJoin";
import YourCards from "views/examples/YourCards";
import HowYouSucceed from "views/examples/HowYouSucceed";
import Ambassador4Brand from "views/examples/Ambassador4Brand&Unkle501";
import AthletePostThisPage from "views/examples/AthletePostThisPage";
import ScrollSign from "views/examples/ScrollSign";
import Tutorials from "views/examples/Tutorials";
import SeasonalBadges from "views/examples/SeasonalBadges";
import AddMementos from "views/AddMementos";
import ResolutionCenter from "views/examples/ResolutionCenter";
import ResolutionDetail from "views/examples/ResolutionDetail";
import Wallet from "views/examples/Wallet";
import Preview from "views/examples/Preview";
import TalkingBadges from "views/examples/TalkingBadges";
import BrandAmbassodarContest from "views/examples/BrandAmbassodarContest";
import SharedResponsibility from "views/examples/SharedResponsibility";
import TutorialsInPage from "views/examples/TutorialsInPage";
import IntellectualProperty from "views/examples/IntellectualProperty";
import RevenueValueRating from "views/examples/RevenueValueRating";
import HappyToHelp from "views/HappyToHelp";
import AddBlogs from "views/AddBlogs";
import BrandAmbassador from "views/examples/BrandAmbassador";
import SearchManager from "views/examples/SearchManager";
import ManagerHelper from "views/ManagerHelper";
import Notifications from "views/examples/Notifications";
import SportsCommunityBadge from "views/examples/SportsCommunityBadge";
import BulletinBoard from "views/examples/BulletinBoard";
import SportBadges from "views/examples/SportBadges";
import Endorsement from "views/examples/Endorsement";

var routes = [
  {
    path: "/happy-to-help",
    name: "Happy to help",
    icon: "ni ni-tv-2 text-primary",
    component: HappyToHelp,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/tutorials",
    name: "Video Tutorials",
    icon: "ni ni-tv-2 text-primary",
    component: Tutorials,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/athlete-contest",
    name: "ATHLETE TALENT CONTEST",
    icon: "ni ni-tv-2 text-primary",
    component: BrandAmbassodarContest,
    layout: "/admin",
    isMenu: false, // Hidden for athletes
  },
  {
    path: "/index",
    name: "Check School IP",
    icon: "ni ni-tv-2 text-primary",
    component: InstructionsReadFirst,
    layout: "/admin",
    isMenu: false, // Hidden for athletes
  },
  {
    path: "/add-mementos",
    name: "Mementos-Create",
    icon: "ni ni-tv-2 text-primary",
    component: AddMementos,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/seasonal-badges",
    name: "Seasonals-Create",
    icon: "ni ni-tv-2 text-primary",
    component: SeasonalBadges,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/talking-badges",
    name: "Talking Badges-Create",
    icon: "ni ni-tv-2 text-primary",
    component: TalkingBadges,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/sports-community-badge",
    name: "Buy FHP Sports Community Badge",
    icon: "ni ni-tv-2 text-primary",
    component: SportsCommunityBadge,
    layout: "/admin",
    isMenu: false, // Hidden for athletes
  },
  {
    path: "/Improve-Chances-To-Sell-Licenses",
    name: "Improve Your Chances To Sell Licenses Here",
    icon: "ni ni-tv-2 text-primary",
    component: ImproveChanceToSellLicenses,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/Ambassador4Brand&Unkle501",
    name: "Chat - WITH FANS FOR PAY",
    icon: "ni ni-tv-2 text-primary",
    component: Ambassador4Brand,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/fans-request",
    name: "Fans Requesting WhatsApp/Zoom Call from Athlete",
    icon: "ni ni-tv-2 text-primary",
    component: FansRequestingSkype,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/profile",
    name: "My Profile",
    icon: "ni ni-tv-2 text-primary",
    component: Profile,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/how-you-succeed",
    name: "HOW YOU SUCCEED",
    icon: "ni ni-tv-2 text-primary",
    component: HowYouSucceed,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/athlete-post-this-ad",
    name: "Athlete Posts This Ad",
    icon: "ni ni-tv-2 text-primary",
    component: AthletePostThisPage,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/scroll-sign",
    name: "Scroll Sign & Posters",
    icon: "ni ni-tv-2 text-primary",
    component: ScrollSign,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/shared-responsibility",
    name: "Shared Responsibility",
    icon: "ni ni-tv-2 text-primary",
    component: SharedResponsibility,
    layout: "/admin",
    showInMenu: true,
  },
  {
    path: "/cards",
    name: "My Card",
    icon: "ni ni-tv-2 text-primary",
    component: YourCards,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/wallet",
    name: "Wallet",
    icon: "ni ni-tv-2 text-primary",
    component: Wallet,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/change-password",
    name: "Change Password",
    icon: "ni ni-tv-2 text-primary",
    component: ChangePassword,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/raise-issue",
    name: "Raise an Issue",
    icon: "ni ni-tv-2 text-primary",
    component: ComplaintForm,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/requested-cities",
    name: "Requested Cities",
    icon: "ni ni-tv-2 text-primary",
    component: RequestedCities,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/requested-sports",
    name: "Requested Sports",
    icon: "ni ni-tv-2 text-primary",
    component: RequestedSports,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/preview",
    name: "Seasonals Sales",
    icon: "ni ni-tv-2 text-primary",
    component: Preview,
    layout: "/admin",
    isMenu: true,
  },

  {
    path: "/resolution-center",
    name: "Resolution Center",
    icon: "ni ni-tv-2 text-primary",
    component: ResolutionCenter,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/videos-tutorials",
    name: "Tutorials",
    icon: "ni ni-tv-2 text-primary",
    component: TutorialsInPage,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/intellectual-property",
    name: "Intellectual Property",
    icon: "ni ni-tv-2 text-primary",
    component: IntellectualProperty,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/athlete-page-list",
    name: "ATHLETE PAGE LIST",
    icon: "ni ni-tv-2 text-primary",
    component: RevenueValueRating,
    layout: "/admin",
    isMenu: true,
  },

  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: Login,
    layout: "/auth",
    isMenu: true,
  },
  {
    path: "/register",
    name: "Register",
    icon: "ni ni-circle-08 text-pink",
    component: Register,
    layout: "/auth",
    isMenu: true,
  },
  {
    path: "/email-verification-pending",
    name: "Email Verification",
    icon: "ni ni-email-83 text-info",
    component: EmailVerificationPending,
    layout: "/auth",
    isMenu: false,
  },
  {
    path: "/forgot-password",
    name: "Forgot Password",
    icon: "ni ni-circle-08 text-pink",
    component: ForgotPassword,
    layout: "/auth",
    isMenu: true,
  },
  {
    path: "/registration-fee",
    name: "Registeration Fee",
    icon: "ni ni-circle-08 text-pink",
    component: RegistrationFee,
    layout: "/auth",
    isMenu: true,
  },
  {
    path: "/CollectiveAlums&Match4Future",
    name: "Match4Future.com",
    icon: "ni ni-tv-2 text-primary",
    component: CollectiveAlumJoin,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/resolution-detail/:id",
    name: "Resolution Detail",
    icon: "ni ni-tv-2 text-primary",
    component: ResolutionDetail,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/notifications",
    name: "Notifications",
    icon: "ni ni-tv-2 text-primary",
    component: Notifications,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/add-blogs",
    name: "Add Blogs",
    icon: "ni ni-tv-2 text-primary",
    component: AddBlogs,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/manager-helper",
    name: "Manager Helper",
    icon: "ni ni-tv-2 text-primary",
    component: ManagerHelper,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/search-manager",
    name: "Manager",
    icon: "ni ni-tv-2 text-primary",
    component: SearchManager,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/brand-ambassador",
    name: "Brand Ambassador",
    icon: "ni ni-tv-2 text-primary",
    component: BrandAmbassador,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/bulletin-board",
    name: "Visibility Board",
    icon: "ni ni-tv-2 text-primary",
    component: BulletinBoard,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/endorsement",
    name: "Endorsement Badges",
    icon: "ni ni-badge text-primary",
    component: Endorsement,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/sport-badges",
    name: "Sport Badges",
    icon: "ni ni-circle-08 text-primary",
    component: SportBadges,
    layout: "/admin",
    isMenu: true,
  },
];
export default routes;
